export default __webpack_public_path__ + "44ebba0e9bd412a21db02471ba0c7a55.svg";